import FormattedMessage from 'I18n/components/FormattedMessage';
import { BreezeRegenerateIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const BreezeRefreshButton = ({
  onRefresh
}) => {
  return /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": "refresh-button",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiAddonCopilotPreview.components.copilotPreview.refreshButton.tooltip"
    }),
    onClick: onRefresh,
    use: "unstyled",
    children: /*#__PURE__*/_jsx(BreezeRegenerateIcon, {
      size: "300",
      color: "text-core-default"
    })
  });
};
export default BreezeRefreshButton;